<template>
  <div class="pb-0 flex flex-wrap card-sidebar">
    <h2 class="title w-full pb-2">
      {{ sectionTitle }}

      <span class="text-sm">
        <a :href="siteUrl" style="color: black" target="_blank" rel="noopener">
          site: {{ siteLabel }}
        </a>
      </span>
    </h2>
    <ProgressBar
      v-if="isLoading && items.length === 0"
      class="text-center"
      mode="indeterminate"
    />

    <div
      v-for="(n, index) in items"
      v-else
      :key="n.id || index"
      class="news-divider pb-3 mb-3 w-full card-content"
    >
      <div class="d-flow-root">
        <a
          v-if="featuredImage(n)"
          :href="exclusiveContent ? undefined : n.link"
          target="_blank"
          rel="noopener"
          style="text-align: center; float: left"
          class="mb-3 w-full"
          :class="{ 'cursor-pointer': exclusiveContent }"
          @click="onArticleClick($event, n)"
        >
          <div class="news-img">
            <img :src="featuredImage(n)" class="news-image w-full" alt="" />
          </div>
        </a>
        <h4>
          <a
            class="news-link"
            :href="exclusiveContent ? undefined : n.link"
            target="_blank"
            rel="noopener"
            :class="{ 'cursor-pointer': exclusiveContent }"
            @click="onArticleClick($event, n)"
          >
            {{ formatTitle(n.title.rendered) }}
          </a>
        </h4>
        <span v-html="$sanitize(n.excerpt.rendered)" />
        <a
          :href="exclusiveContent ? undefined : n.link"
          target="_blank"
          rel="noopener"
          class="see_more cursor-pointer py-1 px-4 text-xs ml-auto"
          :class="{ 'p-disabled': openingId === n.id }"
          @click="onArticleClick($event, n)"
        >
          {{ $t("see_more") }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    exclusiveContent: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isLoading: true,
      openingId: null,
    };
  },
  computed: {
    sectionTitle() {
      return this.exclusiveContent
        ? this.$t("exclusive_content")
        : this.$t("news");
    },
    siteUrl() {
      return this.exclusiveContent
        ? process.env.VUE_APP_BALCAO_MAIS_WP_URL || "https://balcaomais.pt"
        : "https://b-emigrante.com/";
    },
    siteLabel() {
      return this.exclusiveContent ? "balcaomais.pt" : "b-emigrante.com";
    },
    items() {
      return this.exclusiveContent
        ? this.$root.balcaoMaisNews
        : this.$root.news;
    },
  },
  created() {
    if (!this.items.length) {
      this.getNews();
    } else {
      this.isLoading = false;
    }
  },
  methods: {
    getNews() {
      const endpoint = this.exclusiveContent
        ? this.$root.api.externalApiBalcaoMaisArticlesSidebar
        : this.$root.api.externalApiBEmigrantePosts;

      this.$root
        .apiWordpressBEGet(endpoint)
        .then((response) => {
          if (this.exclusiveContent) {
            this.$root.balcaoMaisNews = response.data || [];
          } else {
            this.$root.news = response.data;
          }
          this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
          const msg =
            error.response && error.response.data
              ? error.response.data.msg_code
              : this.exclusiveContent
              ? "error_loading_articles"
              : undefined;
          if (msg) {
            this.$root.toastError(msg);
          }
        });
    },
    featuredImage(article) {
      const media = article._embedded && article._embedded["wp:featuredmedia"];
      const item = media && media[0];
      if (!item || item.code === "rest_forbidden" || !item.source_url) {
        return null;
      }
      const sizes = item.media_details && item.media_details.sizes;
      if (sizes) {
        return (
          (sizes.large && sizes.large.source_url) ||
          (sizes.medium_large && sizes.medium_large.source_url) ||
          (sizes.medium && sizes.medium.source_url) ||
          item.source_url
        );
      }
      return item.source_url;
    },
    formatTitle(title) {
      return (title || "").replace(
        /(&#(\d+);)/g,
        function (match, capture, charCode) {
          return String.fromCharCode(charCode);
        }
      );
    },
    onArticleClick(event, article) {
      if (!this.exclusiveContent) {
        return;
      }
      event.preventDefault();
      this.openArticle(article);
    },
    openArticle(article) {
      if (this.openingId === article.id) {
        return;
      }
      this.openingId = article.id;
      this.$root
        .apiPost(this.$root.api.balcaoMaisContentToken, {
          articleId: article.id,
          articleUrl: article.link,
        })
        .then(({ data }) => {
          window.open(data.redirectUrl || article.link, "_blank", "noopener");
        })
        .catch(() => this.$root.toastError("error_generating_token"))
        .finally(() => {
          this.openingId = null;
        });
    },
  },
};
</script>
